import styled from 'styled-components';
import Button from '../../Button';
import { IoClose } from 'react-icons/io5';
import { FiPlus } from 'react-icons/fi';
import common from '../../../styles/common';
import {
  detailsBackground,
  outlineGray,
  primaryColor,
  subMenuDropdownBackground,
  textGrey,
} from '../../../config/colors';

export const Wrapper = styled.div`
  min-width: 50rem;
  min-height: 25rem;
  position: relative;
  padding: 1.5rem;
  background-color: ${subMenuDropdownBackground};
`;

export const ModalTitle = styled.p`
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 2rem;
`;

export const CloseButton = styled(Button).attrs({
  wrapperStyle: {
    position: 'absolute',
    top: 10,
    right: 10,
    width: '1.75rem',
    height: '1.75rem',
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  type: 'rounded',
  icon: IoClose,
  iconProps: {
    color: 'rgba(0,0,0,0.7)',
    size: '1.75rem',
  },
})``;

export const ContentWrapper = styled.div`
  display: flex;
`;

export const LeftSide = styled.div`
  width: 22rem;
  margin-right: 7rem;
  padding-top: 1rem;
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  width: 27rem;
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 2rem;
  > *:not(:last-child) {
    margin-right: 0.5rem;
  }
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  ${common.input}
`;

export const FramesInput = styled.input`
  width: 4rem;
  margin-right: 1rem;
  text-align: center;
  ${common.input}
`;

export const FamilyCodeDescWrapper = styled.div`
  margin-bottom: 2rem;
  > *:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`;

export const LeftSideBottomWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const ModuleLengthSvgWrapper = styled.div`
  width: 8rem;
  height: 11rem;
  border: 2px solid ${outlineGray};
`;

export const ModuleOptionsWrapper = styled.div`
  // width: 11rem;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.span`
  font-size: 0.75rem;
  margin-bottom: ${({ marginBottom }) => marginBottom};
`;

export const CheckboxesWrapper = styled.div`
  margin: 1rem 0;
`;

export const ReferenceModuleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RemoveReferenceBtn = styled(Button).attrs({
  wrapperStyle: {
    width: 'fit-content',
    height: 'fit-content',
  },
  type: 'transparentBackgroundButton',
  textStyle: {
    color: primaryColor,
    fontSize: '0.75rem',
  },
})``;

export const ReferenceModuleImageWrapper = styled.div`
  margin-right: 0.5rem;
  height: 6rem;
  flex: 1;
  border: 2px solid ${outlineGray};
`;

export const SelectableReferenceModuleDiv = styled.div`
  position: relative;
  height: 100%;
  :hover {
    cursor: pointer;
  }
`;

export const ReferenceModuleImage = styled.img`
  width: 100%;
  height: 100%;
`;

export const PlusIcon = styled(FiPlus)`
  font-size: 1.5rem;
  color: darkGray;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ReferenceModuleInfoWrapper = styled.div`
  flex: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const BespokeIntentTextfield = styled.textarea`
  width: 100%;
  height: 100%;
  min-height: 200px;
  overflow-y: auto;
  border: solid ${outlineGray};
  border-width: 4px 2px;
  margin-bottom: 1.5rem;
  resize: none;
  padding: 0.5rem;
  border-radius: 0.5rem;
  line-height: 1.3;
  font-size: 0.75rem;
  font-style: inherit;
  ::placeholder {
    font-size: 0.75rem;
  }
`;

export const RemoveModuleBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '250px',
    backgroundColor: detailsBackground,
  },
  textStyle: {
    color: primaryColor,
  },
})``;

export const HelperWrapper = styled.div`
  width: ${({ width }) => width || '50%'};
  display: flex;
  flex-direction: column;
`;
